import { createAction } from 'redux-actions';

export const getDocuments = createAction('GET_DOCUMENTS');
export const getDocumentsSuccess = createAction('GET_DOCUMENTS_SUCCESS');
export const getDocumentsFailure = createAction('GET_DOCUMENTS_FAILURE');

export const createDocument = createAction('CREATE_DOCUMENT');
export const createDocumentSuccess = createAction('CREATE_DOCUMENT_SUCCESS');
export const createDocumentFailure = createAction('CREATE_DOCUMENT_FAILURE');

export const deleteDocument = createAction('DELETE_DOCUMENT');
export const deleteDocumentSuccess = createAction('DELETE_DOCUMENT_SUCCESS');
export const deleteDocumentFailure = createAction('DELETE_DOCUMENT_FAILURE');

export const getDocument = createAction('GET_DOCUMENT');
export const getDocumentSuccess = createAction('GET_DOCUMENT_SUCCESS');
export const getDocumentFailure = createAction('GET_DOCUMENT_FAILURE');
